<template>
  <a-modal v-model="modal" title="批量修改" width="500px" :maskClosable="false" :closable="false" :destroyOnClose="true">
    <a-form-model :model="formData" ref="form">
      <a-form-model-item
        label="备注"
        :labelCol="{ style: 'width: 50px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 50px ) !important;float:left'}"
        prop="remark"
      >
        <a-input v-model="formData.remark" allowClear :maxLength="150" />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="modal=false;">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep'

export default {
  name: 'BatchEditModal',
  data() {
    return {
      modal: false,
      dataList: [], // 选择数据
      formData: { remark: "" },
      loading: false
    }
  },
  methods: {
    moment,
    show (data) {
      this.$set(this.formData, 'remark', "")
      this.dataList = cloneDeep(data);
      this.modal = true
    },
    submit () {
      this.dataList.forEach((item) => {
        item.remark = this.formData.remark
      })
      this.$emit('updateRemark', this.dataList)
      this.$message.success('修改完成!')
      this.modal = false
    }
  }
}
</script>

<style scoped>

</style>
